import { Spacing } from '@persona-id/design-tokens';
import { CaretDownIcon } from '@persona-id/design-tokens/icons';
import { ReactNode } from 'react';
import styled from 'styled-components';

import { Paragraph } from 'design-system/components/Text';
import { TransitionDuration } from 'design-system/variables/transitions';
import useToggle from 'lib/hooks/useToggle';

interface ExpandableContentProps {
  id: string;
  title: string;
  children: ReactNode;
  disabled?: boolean;
}

export const ExpandableContent = ({ id, title, children, disabled }: ExpandableContentProps) => {
  const [expanded, { toggle: toggleExpanded }] = useToggle(false);
  return (
    <>
      <ExpandableButton
        type='button'
        id={`expandable-content__button-${id}`}
        onClick={toggleExpanded}
        aria-expanded={expanded}
        aria-controls={`expandable-content__content-${id}`}
        disabled={disabled}
      >
        <ButtonContainer>
          {/* @ts-expect-error [strict-migration] The following line is not strict; please fix! */}
          <StyledCaretDownIcon $expanded={expanded} disabled={disabled} />
          <Paragraph size='sm' color={disabled ? `disabled` : `secondary`}>
            {title}
          </Paragraph>
        </ButtonContainer>
      </ExpandableButton>
      {expanded && (
        <ExpandableContentContainer id={`expandable-content__content-${id}`}>
          {children}
        </ExpandableContentContainer>
      )}
    </>
  );
};

const StyledCaretDownIcon = styled(CaretDownIcon)<{
  $expanded: boolean;
  disabled: boolean;
}>`
  transition: transform ${TransitionDuration.Fast};
  transform: rotate(${({ $expanded }) => ($expanded ? '0' : '-90deg')});
  color: ${({ theme, disabled }) =>
    disabled ? theme.color.text.disabled : theme.color.text.secondary};
`;

const ButtonContainer = styled.span`
  display: grid;
  grid-template-columns: ${Spacing[4]} 1fr;
  grid-gap: 2px;
  align-items: center;
  margin-left: -${Spacing[1]};
`;

const ExpandableButton = styled.button`
  background-color: transparent;
  cursor: pointer;
  text-align: left;
`;

const ExpandableContentContainer = styled.div`
  margin-left: 14px;

  & > ul {
    list-style: none;
  }
`;
